import React from "react";

export default function VideoPoster({
  src,
  label = "Intro",
  duration = "0:18",
  onPlay,
  state = "idle", // idle | active | done
  className = "",
}) {
  return (
    <button
      data-testid="video-poster"
      onClick={onPlay}
      className={`group relative overflow-hidden rounded-2xl text-left ${
        state === "active" ? "ring-gold" : ""
      } ${className}`}
      style={{ aspectRatio: "4 / 5" }}
    >
      <img
        src={src}
        alt=""
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#05070d] via-[#05070d]/30 to-transparent" />
      {/* Play button */}
      <div className="absolute inset-0 grid place-items-center">
        <span className="relative grid place-items-center h-16 w-16 rounded-full glass-strong backdrop-blur-xl transition-transform group-hover:scale-[1.08]">
          <span className="absolute inset-0 rounded-full animate-pulse-ring" />
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-[#D4AF37] translate-x-[1px]"
          >
            <path d="M8 5v14l11-7L8 5Z" />
          </svg>
        </span>
      </div>
      {/* meta */}
      <div className="absolute top-3 left-3 right-3 flex items-center justify-between text-[11px]">
        <span className="glass rounded-full px-2.5 py-1 uppercase tracking-[0.18em] text-white/75">
          {label}
        </span>
        <span className="glass rounded-full px-2 py-1 font-mono text-white/75">
          {duration}
        </span>
      </div>
    </button>
  );
}
